@if (visible && alert) {
  <div class="alert-timer-stack" aria-live="polite" aria-atomic="true">
    <div class="alert-card {{ alert.class }} animated slideInUp">
      <div class="alert-card__content">
        <div class="alert-card__icon" aria-hidden="true">
          <i class="{{ alert.icon }}"></i>
        </div>

        <div class="alert-card__message">
          <span class="alert-card__text">{{ alert.description }}</span>
          <span class="alert-timer__countdown">{{ countdownText }}</span>
        </div>

        @if (alert.actionLabel) {
          <button type="button" class="alert-timer__action" (click)="cancelAlert()">
            {{ alert.actionLabel }}
          </button>
        }

        @if (!alert.hideClose) {
          <button
            type="button"
            class="alert-card__close"
            aria-label="Close"
            (click)="cancelAlert()"
          >
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        }
      </div>

      <div class="alert-timer__progress" role="progressbar" [attr.aria-valuenow]="progressPercent" aria-valuemin="0" aria-valuemax="100">
        <div class="alert-timer__progress-bar" [style.width.%]="progressPercent"></div>
      </div>
    </div>
  </div>
}